module.exports = __webpack_public_path__ + "img/electronic_electric_reserved.d40c7551.svg";